module.exports = __webpack_public_path__ + "static/media/wealth-logo.dd3a2f66.jpg";